module.exports = __webpack_public_path__ + "img/map.92bdd6a6.png";